// extracted by mini-css-extract-plugin
export default {"root":"NoImage-root","title":"NoImage-title","description":"NoImage-description"};